import UIComponent from "../../common/UIComponent";
import "./index.css";

export default class MiddlePlayBtn extends UIComponent {
  constructor(elementId, interfaces) {
    super();
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.init();

    this.interfaces.on(VhallPlayer.PLAY, () => {
      this.playBtnContainer.classList.add("hide");
      const controls = document.querySelector(`${this.elementId} .vhallPlayerh5-shadow`);
      controls && controls.classList.remove("hide");
    });

    this.interfaces.on(VhallPlayer.PAUSE, () => {
      this.playBtnContainer.classList.remove("hide");
    });
  }

  init() {
    this.playBtnContainer = document.createElement("div");
    this.playBtnContainer.setAttribute("class", 'vh-playBtnContainer');
    this.playBtnContainer.onclick = this.handleClick.bind(this);

    this.playBtn = document.createElement("i")
    this.playBtn.setAttribute("class", 'light-vh-playBtn');

    this.playBtnContainer.appendChild(this.playBtn);
    this.appendChild(this.elementId, this.playBtnContainer);
  }

  handleClick() {
    this.interfaces.play();
    this.playBtnContainer.classList.add("hide");
  }
}